import * as core from '../../../../../../../core'

import { query } from './overview-trends.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.overview.widgets.trends',
    description:
      'Bar chart with 2022, 2023, and 2024 Institution level TDC Expense',
    name: 'RP Overview - Trends',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
